<template>
    <div>
        <auth-claim-detail :type="2" :id="id"></auth-claim-detail>
    </div>
</template>

<script>
import AuthClaimDetail from '@/views/user/components/auth-claim-detail';
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{AuthClaimDetail},
    data(){
        return{}
    }
}
</script>